import { atom } from '@cloudio-saas/statex';
import { TooltipData } from './TooltipWrapper';

export const canvasGridTooltipAtom = atom<TooltipData | undefined>({
  path: ['transient', 'canvasGridTooltip', ':appUid', ':pageId', ':gridItemId'],
  defaultValue: undefined,
});

export interface HeaderIconState {
  sort: number;
  filter: number;
  ellipsis: number;
}

export const canvasGridIconStateAtom = atom<HeaderIconState | undefined>({
  path: [
    'transient',
    'canvasGrid',
    ':appUid',
    ':pageId',
    ':gridItemId',
    ':columnItemId',
  ],
  defaultValue: undefined,
});
